<template>
  <div class="contact">
    <div class="contact__container">
      <h1 class="contact__container--p">
        ثبت شکایات
      </h1>
      <div class="contact__container--info">
        <div class="j3">
          <label for="">نام*</label>
          <input
            type="text"
            placeholder="نام"
            class="contact__container--info-email"
            v-model="info.name"
          />
        </div>
        <div class="j3">
          <label for="">ایمیل*</label>
          <input
            type="text"
            placeholder="ایمیل"
            class="contact__container--info-email"
            v-model="info.email"
          />
        </div>
        <div class="j3">
          <label for="">شماره همراه</label>
          <input
            type="text"
            placeholder="شماره همراه"
            class="contact__container--info-email"
            v-model="info.pho"
            style="direction: ltr"
          />
        </div>
        <div class="j3">
          <label for="">متن*</label>
          <textarea
            placeholder="متن شما"
            class="contact__container--info-text"
            v-model="info.text"
            name=""
            id=""
            cols="30"
            rows="10"
          ></textarea>
        </div>

        <button @click.prevent="send" class="contact__container-btn">
          ارسال
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      per: true,
      info: {
        name: "",
        email: "",
        pho: "",
        text: ""
      }
    };
  },
  methods: {
    send() {
      function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }
      var that = this;
      this.$store.state.load = true;
      if (
        this.info.name.length == 0 ||
        this.info.text.length == 0 ||
        this.info.email.length == 0
      ) {
        that.$toastr.e("لطفا فیلد های مشخص شده را پر کنید.");
        that.$store.state.load = false;
      } else if (this.info.name.length > 63) {
        that.$toastr.e("نام وارد شده بیشتر از حد مجاز است.");
        that.$store.state.load = false;
      } else if (!validateEmail(this.info.email)) {
        that.$toastr.e("لطفا ایمیل معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.info.pho < 11 && this.info.pho != 0) {
        that.$toastr.e("لطفا شماره همراه معتبر وارد کنید.");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/contact/create/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          //   headers: {
          //     Authorization: "Bearer" + " " + sessionStorage.getItem("profile")
          //   },
          type: "POST",
          data: {
            name: this.info.name,
            email: this.info.email,
            cellphone: this.info.pho,
            message: this.info.text
          },
          success: function(data, textStatus, request) {
            that.$toastr.s(data);
          },
          error: function(request, textStatus, errorThrown) {
            that.$toastr.e(request.responseJSON);
          },
          complete: function() {
            that.$store.state.load = false;
          }
        });
      }
    }
  },
  created() {
    this.$store.state.load = true;
    var that = this;
    that.$store.state.load = false;
  }
};
</script>
<style lang="scss" scoped>
.j1 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    // width: 93%;
    background: red;
    @media screen and (max-width: 500px) {
      // width: 93%;
      font-size: 0.8em;
    }
  }
}
.j2 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    // width: 96%;
    // background: red;
    // background: red;
    @media screen and (max-width: 500px) {
      // width: 93%;
      font-size: 0.8em;
    }
  }
}
.j3 {
  display: flex;
  flex-direction: column;
  // background: olive;
  width: 100%;
  label {
    margin-right: 1.5em;
    font-size: 0.8em;
  }
  input {
    direction: rtl !important;
    // width: 98%;
    // background: red;
    @media screen and (max-width: 500px) {
      width: 93%;
      font-size: 0.8em;
    }
  }
}
.contact {
  width: 100%;
  height: auto;
  // background: red;
  margin-top: 7.9em;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 500px) {
    font-size: 0.6em;
  }
  &__container {
    display: flex;
    flex-direction: column;
    direction: rtl;
    padding: 3em;
    justify-content: center;
    // align-items: center;
    // background: red;
    width: 60%;
    @media screen and (max-width: 1000px) {
      width: 100%;
    }
    @media screen and (max-width: 500px) {
      width: 100%;
    }
    &-btn {
      text-decoration: none;
      border: none;
      padding: 1em;
      color: var(--main-color);
      background: var(--sub-color);
      font-family: "yekan";
      margin-top: 2em;
      border-radius: 8px;
      cursor: pointer;
      width: 100%;
      margin-right: auto;
      margin-left: auto;
      // transform: translate(5.5%);
    }
    &--p {
      font-family: 0.9em;
      margin-bottom: 1em;
    }
    &--info {
      border-radius: 8px;
      background: var(--main-color);
      border: 1px solid rgb(194, 214, 219);
      height: auto;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.164);
      display: flex;
      flex-direction: column;
      padding: 1em;
      //   background: red
      padding: 4em;
      &-text {
        width: 97%;
        color: var(--font-color);
        font-family: "yekan";
        // width: auto;
        border: none;
        background: var(--bg-color);
        padding: 1em;
        margin: 1em;
        border-radius: 8px;
        direction: rtl;
        resize: none;
      }
      textarea {
        direction: rtl !important;
        width: 95%;
      }
      input {
        color: var(--font-color);
        font-family: "yekan";
        // width: auto;
        border: none;
        background: var(--bg-color);
        padding: 1em;
        margin: 1em;
        border-radius: 8px;
        direction: rtl;
      }
      &-fname {
        width: 50%;
      }
      &-lname {
        width: 50%;
      }
    }
  }
}
.con7 {
  //   background: red;
  width: 100%;
  display: flex;
}
.edit {
  background: var(--main-color) !important;
  border: 1px solid var(--sub-color) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/enteghad/contact_us.vue